import React, { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { GetUtcMidnightDate } from "shared/helpers/DateHelpers";

import {
  SharedFormRow,
  SharedFormColumn,
} from "components/layout/SharedFormElements/SharedFormRowAndColumns";
import KendoDropdown from "components/form/KendoDropdown";
import { UserContext } from "shared/context/UserContext";
import { ToLocationOptions } from "shared/helpers/LocationOptionHelpers";

export default function AdminPaymentMatchingForm(props) {
  const { handleFormSubmit } = props;
  const [serviceDate, setServiceDate] = useState("");
  const [selectedParentCompany, setSelectedParentCompany] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  // const [reconArchive, setReconArchive] = useState(false);
  const [showOnlyArchivedRemits, setShowOnlyArchivedRemits] = useState(false);
  const [rxNumber, setRxNumber] = useState("");

  const userContext = useContext(UserContext);
  const parentCompanyOrganizations = userContext.organizations ? userContext.organizations.filter(
    (org) => org.type === "ParentCompany"
  ) : [];
  const [payerDataSource, setPayerDataSource] = useState([]);
  const [locationFormatedDataSource, setLocationFormatedDataSource] = useState(
    []
  );

  const location = useLocation();

  useEffect(() => {
    getPayer();
  }, []);

  function clearLocationDataSource() {
    setLocationFormatedDataSource([
      {
        label: "",
        value: "",
      },
    ]);
  }

  useEffect(() => {
    getUserLocation();
  }, [selectedParentCompany, userContext.isUnrestrictedEraPath]);

  function submitForm() {
    let parameters = {
      //NOTE TODO: This should work, but check on the API call it's getting set to the correct time
      serviceDate: serviceDate ? GetUtcMidnightDate(serviceDate) : null,
      rpid: selectedParentCompany ? selectedParentCompany.value : null,
      mmid: selectedLocation ? selectedLocation.value : null,
      rxNumber: rxNumber,
      // reconArchive: reconArchive,
      showOnlyArchivedRemits: showOnlyArchivedRemits,
      user: userContext.email
    };

    let validationIssueMessage = "";

    if(!parameters.rpid) {
      validationIssueMessage = "Please select a Parent Company.";
    }
    if(!parameters.rxNumber) {
      validationIssueMessage = "Please enter a Rx Number.";
    }

    if (validationIssueMessage) {
      alert(validationIssueMessage);
    } else {
      handleFormSubmit(parameters);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    submitForm();
  }

  function clearForm() {
    setServiceDate("");
    setSelectedParentCompany("");
    setRxNumber("");
    // setReconArchive(false);
    setShowOnlyArchivedRemits(false);

    clearLocationDataSource();
    setSelectedLocation([]);
  }

  async function getPayer() {
    setPayerDataSource([]);
    let parameters = {
      email: userContext.email,
    };
    let accessToken = props.passedProps.auth.getAccessToken();
    let currentRoute = location.pathname;
    let header = {
      Authorization: `Bearer ${accessToken}`,
    };

    let payerResponse = await axios.get(`api/UserProgram/GetAllPayers`, {
      params: parameters,
      headers: header,
    });

    let PayerList = Object.keys(payerResponse.data).map((key) => {
      return {
        label: payerResponse.data[key],
        value: key,
      };
    });

    let sortedPayers = PayerList.sort((p1, p2) =>
      p1.label > p2.label ? 1 : p1.label < p2.label ? -1 : 0
    );

    setPayerDataSource(sortedPayers);
  }
  async function getUserLocation() {
    //if selectedparentcompany is null or undefined, do not set the location data source
    if (
      !selectedParentCompany ||
      selectedParentCompany == undefined ||
      !selectedParentCompany.value
    ) {
      return;
    }

    let allLocationsParameters = {
      email: userContext.email,
      selectedItem: selectedParentCompany.value,
      organizationType: "ParentCompany",
      programSubscriptions: "RecMetric2.0",
    };
    let accessToken = props.passedProps.auth.getAccessToken();
    let allLocationsResponse = await axios.get(
      `api/UserProgram/GetUserLocationsDetails`,
      {
        params: allLocationsParameters,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          RequestSrc: "/",
        },
      }
    );

    //if no data then exit without setting the location data source
    if (!allLocationsResponse.data || allLocationsResponse.data == undefined) {
      return;
    }

    // console.log("allLocationsResponse", allLocationsResponse.data);
    if (allLocationsResponse.data.length > 0) {
      let allLocations = ToLocationOptions(allLocationsResponse.data);
      setLocationFormatedDataSource(allLocations);
    }
  }
  function resetOnClick() {
    clearForm();
    props.handleFormReset();
  }

  return (
    <Form onSubmit={handleSubmit}>
      <SharedFormRow>
        <SharedFormColumn>
          <Form.Label>Parent Company</Form.Label>

          <KendoDropdown
            dataSource={parentCompanyOrganizations || []}
            textField="labelNoSuffix"
            idField="value"
            value={selectedParentCompany}
            sortBy="asc"
            onChange={(e) => {
              setSelectedLocation(null);
              clearLocationDataSource();

              setSelectedParentCompany(e);
            }}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Recon Archive?</Form.Label>
          <Form.Check
            type="checkbox"
            // label="Recon Archive?"
            // onChange={(event) => {
            //   setReconArchive(event.target.checked);
            // }}
            disabled
            // checked={true}
            checked={selectedParentCompany && selectedParentCompany.isReconArchive ? true : false}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Location (NCPDP)</Form.Label>

          <KendoDropdown
            dataSource={locationFormatedDataSource}
            textField="label"
            idField="value"
            value={selectedParentCompany != null ? selectedLocation : null}
            onChange={(e) => {
              setSelectedLocation(e);
            }}
          />
        </SharedFormColumn>
      </SharedFormRow>
      <SharedFormRow>
        <SharedFormColumn>
          <Form.Label>Rx Number</Form.Label>
          <Form.Control
            type="text"
            name="rxNumber"
            value={rxNumber}
            onChange={(e) => {
              setRxNumber(e.target.value);
            }}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Service Date</Form.Label>
          <Form.Control
            name="serviceDate"
            as={DatePicker}
            selected={serviceDate}
            onChange={(date) => setServiceDate(date)}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Show Only Archived Remits?</Form.Label>
          <Form.Check
            type="checkbox"
            // label="Show Only Archived Remits?"
            onChange={(event) => {
              setShowOnlyArchivedRemits(event.target.checked);
            }}
            checked={showOnlyArchivedRemits}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Button className="inline-show-result-button" size="sm" type="submit">
            Show Results
          </Button>
        </SharedFormColumn>
        <SharedFormColumn>
          <Button
            className="inline-show-result-button"
            size="sm"
            type="button"
            onClick={resetOnClick}
          >
            Reset
          </Button>
        </SharedFormColumn>
      </SharedFormRow>
    </Form>
  );
}
